export default "__VITE_ASSET__CifvH8ZQ__"